<template>
  <div class="xy-module-content">
    <div class="xy-module-title van-hairline--bottom">
      <form action="javascript:void 0">
        <input v-model="searchText"
               type="search"
               class="xy-search-box van-hairline--surround"
               @keyup.13="searchBtn"
               placeholder="请输入主题名称或发文字号" />
      </form>
      <div @click="viewBtn">筛选</div>
    </div>
    <div class="xy-module-body">
      <van-pull-refresh v-model="isLoading"
                        @refresh="onRefresh">
        <van-list v-model="loading"
                  :finished="finished"
                  finished-text="没有更多了"
                  @load="onLoad"
                  class="xy-van-list">
          <div v-for="item in list"
               :key="item.DocumentID"
               class="xy-list">
            <div class="xy-list-wrap">
              <div class="xy-list-title">
                <!-- <div class="xy-list-title-text"> -->
                  <!-- <div class="comm-title jj">
                    <span>普通</span>
                    <span>关于组织《会是多少第三帝国但是但是多所多【紧急】关于组织《会是多少第三帝国但是但是多所多但是但是多杀死对手但是是多所多但是但是多杀死对手但是但是但是多杀死对手但是是多所多但是但是多杀死对手但是</span>
                  </div> -->
                <div class="xy-list-title-text"
                   v-html="item.Title"></div>
                <!-- </div> -->
              </div>
              <div class="xy-flex box">
                <div class="xy-list-ms nowrap">
                  <span class="xy-list-ms-label">发起时间：</span>
                  <span class="xy-list-ms-text">{{ xy.moment(item.CreatedTime).format('YYYY.MM.DD') }}</span>
                </div>
                <!-- <div class="xy-list-ms nowrap">
                  <span class="xy-list-ms-label">发起人：</span>
                  <span class="xy-list-ms-text">{{ item.CreatedByName }}</span>
                </div> -->
                <!-- <div class="xy-list-ms nowrap">
                  <span class="xy-list-ms-label">公文种类：</span>
                  <span class="xy-list-ms-text">{{ item.DocumentTypeName }}</span>
                </div> -->
              </div>
            </div>
            <div class="xy-list-footer van-hairline--top"
                 @click="detailsDoc(item.DocumentID,item.CreatedByID,item)">
              <p class="xy-list-title-status"
                 :class="item.DocumentStatus === 1 ? 'xy-status-color-success' : item.DocumentStatus === 2 ? 'xy-status-color-info' : (item.DocumentStatus === 4 || item.DocumentStatus === 16) ? 'xy-status-color-default' : item.DocumentStatus === 8 ? 'xy-status-color-wait' : ''">{{item.DocumentStatus === 1 ? '进行中' : item.DocumentStatus === 2 ? '申请结束' : item.DocumentStatus === 4 ? '已结束' : item.DocumentStatus === 8 ? '未签收' : item.DocumentStatus === 16 ? '已撤销' : ''}}</p>
              <div class="desc">
                <div class="xy-list-footer-text">查看详情</div>
                <div class="xy-list-footer-icon">
                  <van-icon name="arrow" />
                </div>

              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <div class="xy-module-footer van-hairline--top">
      <div class="xy-module-footer-btn"
           @click="publishDoc">发起公文</div>
    </div>
    <ViewSearch :isView="isView"
                :statusList="statusList"
                @listenToChildClose="closeSearch"
                @listenToChildCSubmit="submitSearch" />
  </div>
</template>
<script>
import ViewSearch from "@/pages/operationalAnalysis/views/documentMove/Search";
export default {
  name: 'DocLaunch',
  components: {
    ViewSearch
  },
  data () {
    return {
      statusList: [
        {
          name: '全部',
          statusID: 0
        },
        {
          name: '进行中',
          statusID: 1
        },
        {
          name: '申请结束',
          statusID: 2
        },
        {
          name: '已结束',
          statusID: 4
        },
        {
          name: '已撤销',
          statusID: 16
        }
      ],
      isView: false,
      list: [],
      loading: false, // 是否加载中
      finished: false, // 加载是否完成
      isLoading: false, //是否处于下拉刷新状态
      num: 1,
      pageSize: 15,
      dataArr: ['', ''],
      searchText: '',
      statusType: 0,
      id: 0,
      id2: 0
    }
  },
  methods: {
    publishDoc () {
      this.$router.push('/home/Doc/launch')
    },
    detailsDoc (id, id2) {
      this.id = id
      this.id2 = id2
      this.$router.push({ path: '/home/Doc/details', query: { docID: this.id, creID: this.id2 } })
    },
    viewBtn () {
      this.isView = true;
    },
    closeSearch (val) {
      this.isView = val
    },
    submitSearch (val) {
      this.isView = false
      this.dataArr[0] = val.startDateChange
      this.dataArr[1] = val.endDateChange
      this.statusType = val.statusID
      this.onRefresh()
    },
    searchBtn () {
      this.onRefresh()
    },
    async onLoad () {
      let res = await this.xyapi.get(`${this.$store.state.apiPath}/api/DocCirculation/GetSendByMePageList`, {
        PageIndex: this.num,
        PageSize: this.pageSize,
        Status: this.statusType,
        beginTime: this.dataArr[0],
        endTime: this.dataArr[1],
        SearchWord: this.searchText
      });
      let _list = res.data.data;
      this.list = [...this.list, ..._list];
      this.loading = false;
      this.num++;
      this.finished = this.list.length >= res.data.totalRecords ? true : false;
    },
    onRefresh () {
      setTimeout(() => {
        this.list = [];
        this.num = 1;
        this.isLoading = false;
        this.onLoad();
      }, 500);
    }
  }
}
</script>
<style lang="less" scoped>
.xy-module-content {
  position: relative;
  .xy-module-title {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 80px;
    padding: 0 40px;
    background: #fff;
    font-size: 28px;
  }
  .xy-module-body {
    margin-bottom: 120px;
    /deep/ .comm-title {
      > span:nth-of-type(1) {
        display: inline-block;
        padding: 2px 10px;
        font-size: 24px;
        border-radius: 24px;
        color: #fff;
        margin-right: 6px;
      }
    }
    /deep/ .pt {
      > span:nth-of-type(1) {
        background: #25c40b;
      }
    }
    /deep/ .jj {
      > span:nth-of-type(1) {
        background: #f5222d;
      }
    }
    .box {
      flex-flow: column nowrap;
    }
    .xy-list-footer-icon {
      display: flex;
      margin-left: 24px;
      > i {
        padding-top: 1px;
      }
    }
    .desc {
      display: flex;
      align-items: center;
    }
  }
  .xy-module-footer {
    height: 120px;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    display: flex;
    align-items: center;
    background: #fff;
    .xy-module-footer-btn {
      width: 96%;
      height: 88px;
      line-height: 88px;
      text-align: center;
      color: #fff;
      font-size: 30px;
      margin: 0 auto;
      background: rgba(41, 128, 254, 1);
      border-radius: 44px;
    }
  }
}
.xy-search-box {
  border: none;
  padding: 0 20px;
  width: 582px;
  height: 62px;
  background: rgba(242, 242, 242, 1);
  border-radius: 31px;
}
.xy-flex-1 {
  flex: 1;
}
.xy-status-color-wait {
  color: rgba(0, 0, 0, 0.65);
}
.xy-status-color-success {
  color: rgba(232, 160, 34, 1);
}
.xy-status-color-info {
  color: rgba(33, 168, 62, 1);
}
.xy-status-color-default {
  color: rgba(216, 55, 55, 1);
}
.xy-van-list {
  margin-bottom: 80px;
}
.xy-list {
  width: 92%;
  margin: 20px auto 0;
  background: rgba(255, 255, 255, 1);
  border-radius: 40px;
  .xy-list-wrap {
    padding: 30px;
    .xy-list-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 50px;
      .xy-list-title-text {
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        font-size: 28px;
        color: rgba(0, 0, 0, 0.85);
        flex: 1;
        padding-right: 40px;
      }
      .xy-list-title-status {
        font-size: 28px;
      }
    }
    .xy-list-ms {
      margin-bottom: 30px;
      .xy-list-ms-label {
        font-size: 28px;
        color: rgba(0, 0, 0, 0.65);
      }
      .xy-list-ms-text {
        font-size: 28px;
        color: rgba(0, 0, 0, 0.85);
      }
    }
  }
  .xy-list-footer {
    padding: 0 30px;
    min-height: 80px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .xy-list-footer-text {
      font-size: 28px;
      color: #267dff;
    }
  }
}
</style>
